import { streetViewProxyPath } from '@attik/types/reportCoverPhoto';

/**
 * Returns the URL for the Street View proxy route.
 * All requests go through /api/streetview which fetches from Google once and
 * caches on disk for 7 days — both server-side (Next data cache) and browser
 * (Cache-Control). The Google API key is never exposed to the client.
 *
 * The route serves one canonical 600×600 image. Display it at any size with CSS
 * or Next `<Image>` width/height. Do not add a size or cache-buster — that is a
 * new Google charge.
 */
export default function callStreetView(address: string): string {
  return streetViewProxyPath(address);
}
